import _ from 'underscore';
import {
  getInstrumentation as getInstrumentationInstance,
  InstrumentationSchema,
} from '@bingads-webui-campaign/instrumentation-setup';
import {
  OdataErrorMapper,
  CampaignApiErrorMapper,
  UrlErrorMapper,
  odataErrorCodes,
  campaignApiErrorCodes,
  invalidDomains,
} from '@bingads-webui-campaign/instrumentation';
import { isInternalUrl } from '@bingads-webui/url-util';
import { AjaxStub, AjaxEventHandler, ErrorStub } from '@bingads-webui/instrumentation-stubs';
import { defaultSchema } from './instrumentation-schema';

const errorMappers = {
  odataErrorMapper: new OdataErrorMapper(odataErrorCodes),
  campaignApiErrorMapper: new CampaignApiErrorMapper(campaignApiErrorCodes),
  urlErrorMapper: new UrlErrorMapper(invalidDomains),
};

const formatNameValue = (name, value) => {
  if (_.isEmpty(value)) {
    return `${name}`;
  } else if (_.isObject(value)) {
    return `${name}|${JSON.stringify(value)}|NetworkIsOnline:${window.navigator.onLine}`;
  }
  return `${name}|${value}`;
};

function stub(instrumentation, serverContext) {
  const stubOptions = {
    pageTrackingId: serverContext && serverContext.PageTrackingId,
    lcid: serverContext && serverContext.CurrentUser && serverContext.CurrentUser.Locale,
  };

  const shouldAddHeaders = ajaxContext => isInternalUrl(ajaxContext.url);
  const eventHandler = new AjaxEventHandler({
    errorMappers,
    shouldAddHeaders,
  });

  const ajaxStub = new AjaxStub({
    stubOptions,
    eventHandler,
    instrumentation,
  });

  const errorStub = new ErrorStub({
    instrumentation,
  });

  ajaxStub.init();
  errorStub.init();
}

export const getInstrumentation = ({ serverContext }) => {
  const {
    CurrentCustomer,
    CurrentAccount,
    CurrentUser,
  } = serverContext;

  const userContext = {
    CurrentCustomer: CurrentCustomer || {},
    CurrentAccount: CurrentAccount || {},
    CurrentUser: CurrentUser || {},
  };

  return getInstrumentationInstance({
    pageTrackingId: serverContext.PageTrackingId,
    errorMappers,
    // eslint-disable-next-line no-undef
    isInDevelopmentMode: process.env.NODE_ENV === 'development',
    userContext,
    applicationName: {
      systemName: 'adlibrary',
      subSystemName: 'ui',
    },
    serverContext: {
      ...serverContext,
      ...userContext,
    },
    objectsToStub: [],
  });
};

export const getInstrumentationService = ({ instrumentation, serverContext, scenario = 'defaultScenario' }) => {
  instrumentation.addScenario({
    scenario: [
      ...defaultSchema.scenario,
      ...InstrumentationSchema.scenario,
    ],
  });

  const defaultScenario = instrumentation[scenario].create();
  const logError = defaultScenario.logError.create();
  const logTrace = defaultScenario.logTrace.create();
  const logMetrics = defaultScenario.logMetrics.create();

  stub(instrumentation, serverContext);

  return {
    instrumentation,
    logError: (name, value = '') => {
      logError.error(formatNameValue(name, value));
    },
    logTrace: (name, value = '') => {
      logTrace.trace(formatNameValue(name, value));
    },
    logMetrics: (name, value = '') => {
      logMetrics.trace(formatNameValue(name, value));
    },
  };
};
